<template>
  <div class="header-content">
    <div class="d-flex full-width justify-content-between align-items-center">
      <img :src="quoteLogo" alt="logo" class="logo-img" :style="logoStyle" />
      <DetailBox
        item-type="Quote"
        :item-id="quote.id"
        :job-id="quote.job_id"
        :addresses-materialized="addressesMaterialized"
        :billing-name="billingCustomerName"
        :billing-address="billingAddress"
        :service-name="serviceAddressLocationName"
        :service-address="serviceAddress"
      />
    </div>
    <div class="quote-details">
      <h3 v-if="quote.name" class="quote-name">
        {{ quote.name || "New Quote" }}
      </h3>
      <p v-if="quote.summary" class="quote-summary">
        {{ quote.summary }}
      </p>
    </div>
    <div class="summary-text">QUOTE SUMMARY</div>
  </div>
</template>

<script lang="ts">
import { formatAddressLines } from "serviceshift-ui/shared/src/mixins";

import { Customizations } from "@/typings/customizations";
import { Quote } from "@/typings/quote";
import DetailBox from "./DetailBox.vue";

export default {
  components: {
    DetailBox
  },
  props: {
    quote: {
      type: Object as () => Quote,
      default: null
    },
    customizations: {
      type: Object as () => Customizations,
      default: null
    }
  },
  computed: {
    quoteLogo() {
      if (this.customizations) {
        const darkLogo = this.customizations.Assets.dark_logo_url;
        return darkLogo.value || darkLogo.default;
      }
      return "";
    },
    customerName() {
      return this.quote?.customer?.full_name ?? "";
    },
    billingCustomerName() {
      return this.quote?.billing_customer?.full_name ?? this.customerName;
    },
    billingAddress() {
      return formatAddressLines(this.quote?.billing_address);
    },
    serviceAddress() {
      return formatAddressLines(this.quote?.service_address);
    },
    serviceAddressLocationName() {
      return this.quote?.service_address?.name ?? "";
    },
    addressesMaterialized() {
      return this.quote?.status === "approved";
    },
    logoStyle() {
      if (this.customizations) {
        const logo_size_percentage =
          this.customizations.General.logo_size_percentage;
        const value =
          logo_size_percentage.value || logo_size_percentage.default;
        return `max-width:${value};`;
      }
      return "";
    }
  },
  mounted() {
    window.tippy("[data-tippy-content]");
  }
};
</script>

<style lang="scss" scoped>
.quote-details {
  margin: 15px 0;
}

.header-content {
  display: flex;
  flex-direction: column;
}

.logo-img {
  max-height: 185px;
  flex-shrink: 0;
}

.summary-text {
  font-size: 14px;
  font-weight: bolder;
  line-height: 16px;
  margin-bottom: 15px;
}

.quote-name {
  margin: 0;
}

.quote-address {
  margin: 8px 0 0 0;
}

.quote-summary {
  margin-top: 8px;
  white-space: pre-line;
}
</style>
